// Aquesta llista no es fa servir, els estudis s'extreuen de Leines
const list_generes = [
    { id: '1', value: '1', ca: ' Home', es: ' Hombre', en: ' Man' },
    { id: '2', value: '2', ca: ' Dona', es: ' Mujer', en: ' Woman' },
    { id: '3', value: '3', ca: ' No binari', es: ' No binario', en: ' No binary' }
];

// Aquesta llista no es fa servir, els estudis s'extreuen de Leines
const list_estudis = [
    { id: 26, value: "Doble Grau en Informàtica de Gestió i Sistemes d'Informació/ Grau en Disseny i Producció de Videojocs"},
    { id: 31, value: "Doble Titulació  Grau en Administració d'Empreses i GI / Grau en Màrqueting i CD"},
    { id: 22, value: "Doble Titulació  Grau en Fisioteràpia / Grau en Ciències de l'Activitat Fisíca i de l'Esport"},
    { id: 32, value: "Doble Titulació  Grau en Turisme i GLL /Grau en Administració d'Empreses i GI"},
    { id: 1, value: "Grau en Administració d'Empreses i Gestió de la Innovació"},
    { id: 25, value: "Grau en Administració d'Empreses i Gestió de la Innovació, docència en anglès"},
    { id: 2, value: "Grau en Ciències de l'Activitat Física i de l'Esport"},
    { id: 24, value: "Grau en Disseny i Producció de Videojocs"},
    { id: 30, value: "Grau en Enginyeria d'Organització Industrial"},
    { id: 17, value: "Grau en Enginyeria Electrònica Industrial i Automàtica"},
    { id: 18, value: "Grau en Enginyeria Informàtica de Gestió i Sistemes d'Informació"},
    { id: 19, value: "Grau en Enginyeria Mecànica"},
    { id: 23, value: "Grau en Fisioteràpia"},
    { id: 28, value: "Grau en Infermeria"},
    { id: 20, value: "Grau en Logística i Negocis Marítims"},
    { id: 33, value: "Grau en Màrqueting i Comunitats Digitals"},
    { id: 16, value: "Grau en Mitjans Audiovisuals"},
    { id: 6, value: "Grau en Turisme i Gestió del Lleure"},
    { id: 21, value: "Máster en Direcció i Planificació del Turisme"},
    { id: 29, value: "Màster Universitari en Atenció Integrada a la Cronicitat i l'Envelliment."},
    { id: 8, value: "Màster Universitari en Cronicitat i Dependència"},
    { id: 7, value: "Màster Universitari en Emprenedoria i Innovació"},
    { id: 34, value: "Màster Universitari en Logística, Cadena de Subministraments i Negocis Marítims"},
    { id: 13, value: "Pla d'Estudis de Mobilitat"},
];

const list_tipus_residencia = [
    { id: 1, value: "1", ca: " Allotjament compartit amb altres estudiants", es: 'Alojamiento compartido con otros estudiantes', en: 'Shared accommodation with other students' },
    { id: 2, value: "2", ca: " Allotjament compartit amb famílies", es:'Alojamiento compartido con famílias', en: 'Shared accommodation with families' },
    { id: 3, value: "3", ca: " Allotjament sense compartir", es: 'Alojamiento sin compartir', en: 'Accommodation without sharing' },
    { id: 4, value: "4", ca: " Residència d'estudiants", es: 'Residencia de estudiantes', en: 'Student\'s residence' }
];

const list_compaginar_estudis = [
    { id: 1, value: "1", ca: "Sí", es: "Sí", en: "Yes" },
    { id: 2, value: "2", ca: "No", es: "No", en: "No" }
];

const list_si_compaginar_estudis = [
    { id: 1, value: "1", ca: "Jornada completa" ,es: 'Jornada completa', en: 'Full time' },
    { id: 2, value: "2", ca: "Menys de 20h/setmana", es: 'Menos de 20h/semana', en: 'Less than 20h/week' },
    { id: 3, value: "3", ca: "Menys de 10h/setmana", es: "Menos de 10h/semana", en: "Less than 10h/week" }
];

const list_estudis_cursats = [
    { id: 1, value: "1", ca: "Batxillerat", es: "Bachillerato" ,en: 'Baccalaureate' },
    { id: 2, value: "2", ca: "Cicles formatius Superiors (CFGS)", es: "Ciclos Formativos Superiores (CFGS)", en: 'Higher Training Cycles (CFGS)' },
    { id: 3, value: "3", ca: "C.O.U.", es: "C.O.U." ,en: 'C.O.U.' },
    { id: 4, value: "4", ca: "Estudis universitaris parcials", es: "Estudios universitarios parciales", en: 'Partial university studies' },
    { id: 5, value: "5", ca: "Estudis universitaris acabats", es: "Estudios universitarios acabados", en: 'Completed university studies' },
    { id: 6, value: "6", ca: "Altres", es: "Otros", en: 'Others' }
];

const list_tipus_batxillerat = [
    { id: 1, value: "1", ca: "Tecnològic", es: "Tecnológico", en: 'Technological' },
    { id: 2, value: "2", ca: "Científic", es: "Científico", en: 'Scientific' },
    { id: 3, value: "3", ca: "Humanístic", es: "Humanístico", en: 'humanistic' },
    { id: 4, value: "4", ca: "Social", es: "Social", en: 'Social' },
    { id: 5, value: "5", ca: "Artístic", es: "Artístico", en: 'Artistic' }
];

const list_seleccio_titulacio = [
    { id: 1, value: "1", ca: "Recomanació d'estudiant o exestudiant", es: "Recomendación de un estudiante o exestudiante", en: 'Recommendation of a student or ex student' },
    { id: 2, value: "2", ca: "Nota de tall", es: "Nota de corte", en: 'Cut-off mark' },
    { id: 3, value: "3", ca: "Proximitat geogràfica", es: "Proximidad geográica", en: 'Geographical proximity' },
    { id: 4, value: "4", ca: "Ambient", es: "Ambiente", en: 'Environment' },
    { id: 5, value: "5", ca: "Reputació del centre", es: "Reputación del centro", en: 'Center reputation' },
    { id: 6, value: "6", ca: "Instal·lacions", es: "Instalaciones", en: 'Facilities' },
    { id: 7, value: "7", ca: "Proximitat del professorat", es: "Proximidad del profesorado", en: 'Proximity of the teaching staff' },
    { id: 8, value: "8", ca: "Pel prestigi del títol UPF", es: "Por el prestigio del título UPF", en: 'For the prestige of the UPF degree' },
    { id: 9, value: "9", ca: "Per les expectatives professionals", es: "Por las expectativas profesionales", en: 'For professional expectations' }
];

const list_com_has_conegut = [
    { id: 1, value: "1", ca: "Recomanació d'un ami/ga o familiar", es: "Recomendación de un amigo/a o familiar", en: 'Recommendation of a friend or relative', disabled: false },
    { id: 2, value: "2", ca: "Perfils del Tecnocampus a les xarxes socials", es: "Perfiles del Tecnocampus en las redes sociales", en: 'Tecnocampus profiles on social networks', disabled: false },
    { id: 3, value: "3", ca: "Buscant dels estudis que m'interessen en cercadors com Google", es: "Buscando de los estudios que me interesan en buscadores como Google", en: 'Searching for the studies that interest me in search engines such as Google', disabled: false },
    { id: 4, value: "4", ca: "Anuncis a internet", es: "Anuncios es internet", en: 'Ads is internet', disabled: true },
    { id: 5, value: "5", ca: "Anuncis a la ràdio", es: "Anuncios en la radio", en: 'Ads is radio', disabled: false },
    { id: 6, value: "6", ca: "Xerrades d'orientació universitària del Tecnocampus", es: "Charlas de orientación universitaria del Tecnocampus", en: 'University orientation talks at the Tecnocampus', disabled: false },
    { id: 7, value: "7", ca: "Jornada de Portes Obertes al Tecnocampus", es: "Jornada de Puertas Abiertas en el Tecnocampus", en: 'Open Day at the Tecnocampus', disabled: false },
    { id: 8, value: "8", ca: "Saló de l'Ensenyament de Barcelona", es: "Salón de la Educación de Barcelona", en: 'Barcelona Education Hall', disabled: false },
    { id: 9, value: "9", ca: "Tallers Xnèrgic o tallers Linnk", es: "Talleres Xnèrgic o talleres Linnk", en: 'Xnèrgic workshops or Linnk workshops', disabled: false },
    { id: 10, value: "10", ca: "Correus informatius que m'ha enviat el Tecnocampus", es: "Correos informativos que me ha enviado el Tecnocampus", en: 'Informative emails that the Tecnocampus has sent me', disabled: false },
    { id: 11, value: "11", ca: "Web Tecnocampus.cat o Futurestudiant.tecnocampus.cat", es: "Web Tecnocampus.cat o Futurestudiant.tecnocampus.cat", en: 'Web Tecnocampus.cat or Futurestudiant.tecnocampus.cat', disabled: false },
    { id: 12, value: "12", ca: "Web UPF", es: "Web UPF", en: 'UPF Web', disabled: false },
    { id: 13, value: "13", ca: "Altres", es: "Otros", en: 'Others', disabled: false }
];

const list_expectatives =  [
    { id: 1, value: "1", ca: "Adquirir coneixements profunds de les àrees pròpies de la titulació", es: "Adquirir conocimientos profundos de las areas propias de la titulación", en: 'Acquire in-depth knowledge of the areas of the degree' },
    { id: 2, value: "2", ca: "Rebre atenció personalitzada i tutorització durant els estudis", es: "Recibir atención personalizada y tutorización durante los estudios", en: 'Receive personalized attention and tutoring during studies' },
    { id: 3, value: "3", ca: "Adquirir un bon coneixement d’idiomes", es: "Adquirir un buen conocimiento de idiomas", en: 'Acquire a good knowledge of languages' },
    { id: 4, value: "4", ca: "Poder fer estades a l’estranger", es: "Poder hacer estancias en el extranjero", en: 'Being able to stay abroad' },
    { id: 5, value: "5", ca: "Poder fer pràctiques en empreses", es: "Poder hacer prácticas en empresas", en: 'Being able to do internships in companies' },
    { id: 6, value: "6", ca: "Rebre docència en anglès", es: "Recibir docencia en inglés", en: 'Receive instruction in English' },
    { id: 7, value: "7", ca: "Aprendre a treballar en equip", es: "Aprender a trabajar en equipo", en: 'Learn to work together' },
    { id: 8, value: "8", ca: "Aprendre a ser autònom en la presa de decisions", es: "Aprender a ser autónomo en la toma de decisiones", en: 'Learn to be autonomous in decision making' },
    { id: 9, value: "9", ca: "Saber expressar-mecorrectament tant oralment com per escrit", es: "Saber expresar-mecorrectamente tanto oralmente como por escrito", en: 'Know how to express myself correctly both orally and in writing' },
    { id: 10, value: "10", ca: "Adquirir competències emprenedores", es: "Adquirir competencias emprendedoras", en: 'Acquire entrepreneurial skills' },
    { id: 11, value: "11", ca: "Facilitar-me la inserció laboral", es: "Facilitarme la inserción laboral", en: 'Facilitate job placement' },
    { id: 12, value: "12", ca: "Poder participar en activitats culturals, esportives o de cooperació", es: "Poder participar en actividades culturales, deportivas o de cooperación", en: 'Being able to participate in cultural, sports or cooperation activities' },
];
const list_canals_comunicacio = [
    { id: 1, value: "1", ca: "Newsletter", es: "Newsletter", en: 'Newsletter' },
    { id: 2, value: "2", ca: "Pàgina web", es: "Página web", en: 'Web' },
    { id: 3, value: "3", ca: "Titok", es: "Titok", en: 'Titok' },
    { id: 4, value: "4", ca: "Instagram", es: "Instagram", en: 'Instagram' },
    { id: 5, value: "5", ca: "Facebook", es: "Facebook", en: 'Facebook' },
    { id: 6, value: "6", ca: "Twitter", es: "Twitter", en: 'Twitter' },
    { id: 7, value: "7", ca: "Correu electrònic", es: "Correo electrónico", en: 'Mail' },
    { id: 8, value: "8", ca: "WhatsApp", es: "WhatsApp", en: 'WhatsApp' },
    { id: 9, value: "9", ca: "Cartells", es: "Carteles", en: 'Posters' },
];

const list_transport = [
    { id: 1, value: "1", ca: "Moto", es: "Moto", en: 'Motorcycle' },
    { id: 2, value: "2", ca: "Cotxe", es: "Coche", en: 'Car' },
    { id: 3, value: "3", ca: "Tren", es: "Tren", en: 'Train' },
    { id: 4, value: "4", ca: "Bus interurbà (Casas, Sagalés...)", es: "Bus interurbano (Casas, Sagalés...)", en: 'Intercity bus (Casas, Sagalés...)' },
    { id: 5, value: "5", ca:"Bus urbà", es:"Bus urbano", en: 'Urban bus' },
    { id: 6, value: "6", ca: "Bicicleta", es: "Bicicleta", en: 'Bicycle' },
    { id: 7, value:"7", ca: "A peu", es: "A pie", en: 'Walking' },
    { id: 8, value:"8", ca: "Altres", es: "Otros", en: 'Others'},
];

const list_qualitat_servei = [
    { id: 1, value: "1", ca: "Molt Bona", es: "Muy buena", en: 'Very good' },
    { id: 2, value: "2", ca: "Bona", es: "Buena", en: 'Good' },
    { id: 3, value: "3", ca: "Normal", es: "Normal", en: 'Normal' },
    { id: 4, value: "4", ca: "Dolenta", es: "Mala", en: 'Bad' },
    { id: 5, value: "5", ca: "Molt Dolenta", es: "Muy mala", en: 'Very bad' },
];

export {
    list_generes,
    list_estudis,
    list_tipus_residencia,
    list_compaginar_estudis,
    list_si_compaginar_estudis,
    list_estudis_cursats,
    list_tipus_batxillerat,
    list_seleccio_titulacio,
    list_com_has_conegut,
    list_canals_comunicacio,
    list_expectatives,
    list_transport,
    list_qualitat_servei
}